import { Button, ButtonGroup, TextField } from '@mui/material';
import { createIconFromName } from '../../../util/iconUtil';
import { ChangeEvent } from 'react';
import { CreatePipelineType } from './types';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../store/hooks';

export const supportedIcons = [
  'photo',
  'burstMode',
  'calculate',
  'shutterSpeed',
  'photoCamera',
  'keyboard',
  'sportsBar',
  'theaters',
  'map',
];

export const defaultCreateFormData = {
  name: '',
  icon: supportedIcons[0],
};

type Props = {
  data: CreatePipelineType;
  onChange: (data: CreatePipelineType) => void;
};

const CreateNewPipeline = ({ data, onChange }: Props): JSX.Element => {
  const { t } = useTranslation();

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange({ ...data, name: event.target.value });
  };

  const handleButtonChange = (icon: string) => () => {
    onChange({ ...data, icon });
  };

  return (
    <>
      <TextField variant={'filled'} label={t('Name')} value={data.name} onChange={handleNameChange} fullWidth />
      <ButtonGroup variant={'outlined'} aria-label={'icon button group'} fullWidth>
        {supportedIcons.map((e, i) => (
          <Button
            key={i}
            variant={e === data.icon ? 'contained' : 'outlined'}
            startIcon={createIconFromName(e)}
            onClick={handleButtonChange(e)}
          />
        ))}
      </ButtonGroup>
    </>
  );
};

export default CreateNewPipeline;
